import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ITagOption, Tags, useDeviceType } from '@cian/ui-kit';

import { promosApplyFiltersRequestAction } from '../../actions/filters';
import { extractJsonQueryAction } from '../../actions/jsonQuery';
import { selectSearchTags } from '../../selectors/tags';
import { TThunkDispatch } from '../../types/redux/thunk';
import { ITag } from '../../types/tags';

export const SearchSuggestTagsContainer: React.FC = () => {
  const tags = useSelector(selectSearchTags);
  const dispatch: TThunkDispatch = useDispatch();
  const deviceType = useDeviceType();

  const displayTags = React.useMemo(
    // value у тегов требует уникального значения, поэтому не используем индекс в качестве него.
    () => tags.map(tag => ({ label: tag.name, value: JSON.stringify(tag.jsonQuery) })),
    [tags],
  );
  const displayModeOptions = React.useMemo(() => {
    return deviceType === 'desktop'
      ? { isFolded: false, isFoldable: false }
      : { isFolded: true, isFoldable: true, maxLines: 4 };
  }, [deviceType]);

  const handleTagClear = React.useCallback(
    ({ value }: ITagOption) => {
      const tag = tags.find(tag => JSON.stringify(tag.jsonQuery) === value) as ITag;

      dispatch(extractJsonQueryAction(tag.jsonQuery));
      dispatch(promosApplyFiltersRequestAction());
    },
    [dispatch, tags],
  );

  if (displayTags.length === 0) {
    return null;
  }

  return (
    <div data-testid="SearchSuggestTags">
      <Tags options={displayTags} displayModeOptions={displayModeOptions} onClose={handleTagClear} />
    </div>
  );
};
